import { IntentPredictionTranscript } from './IntentPredictionTranscript';
import { InteractiveWidgetTranscript } from './InteractiveWidgetTranscript';
import { SpeechTranscript } from './SpeechTranscript';
import { VoiceTranscript } from './types';
import { WidgetResponseTranscript } from './WidgetResponseTranscript';
import { WidgetTranscript } from './WidgetTranscript';

export const TranscriptComponent = ({
  startTime,
  transcript,
  widgetByBatchId,
}: {
  startTime: number;
  transcript: VoiceTranscript;
  widgetByBatchId: Map<string, VoiceTranscript>;
}) => {
  if (transcript.type === 'execution') {
    return <IntentPredictionTranscript transcript={transcript} />;
  }

  if (transcript.type === 'widget') {
    if (
      transcript.widget_type === 'form' ||
      transcript.widget_type === 'buttons' ||
      transcript.widget_type === 'dynamic_card'
    ) {
      return (
        <InteractiveWidgetTranscript
          startTime={startTime}
          transcript={transcript}
        />
      );
    }
    return <WidgetTranscript startTime={startTime} transcript={transcript} />;
  }

  if (transcript.type === 'widget_response') {
    return (
      <WidgetResponseTranscript
        transcript={transcript}
        widgetByBatchId={widgetByBatchId}
      />
    );
  }

  return <SpeechTranscript startTime={startTime} transcript={transcript} />;
};
